import { memo } from 'react';
import { IconProps } from './iconType';

export const ArrowLeftIcon = memo(({ size, color }: IconProps) => {
  return (
    // export된 svg가 있다면 => 코드창에 열어서 있는 코드 아래 형식처럼 수정하기
    // 디자인 파일에서 svg가 있다면 => svg 코드 복사해서 아래 형식처럼 수정하기
    // xmlns 속성은 제거
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
      <path
        d="M14.666 16L20.888 22.222L19.111 24L11.111 16L19.111 8L20.889 9.778L14.666 16Z"
        fill={color}
      />
    </svg>
  );
});

ArrowLeftIcon.displayName = 'ArrowLeftIcon';
